<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/dj8KmS/tc-custom/9781439677902.jpg?1704886579331" alt="This image is the cover for the book Yankees in the Hall of Fame, Images of Baseball"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Yankees in the Hall of Fame, Images of Baseball
      </h1>
      <p class="bookDescription body article font2">
        <p>The New York Yankees are the most successful franchise in the history of sports. When they were founded as the New York Highlanders, no one could have imagined how high they would land, capturing 40 American League pennants and a staggering 27 World Series championships. Many of baseball's all-time greats have shined in Yankee pinstripes on their way to the Baseball Hall of Fame. The dynasty's birth featured Babe Ruth and Lou Gehrig in the "House that Ruth Built." Legendary greats followed: Joe DiMaggio, Yogi Berra, Mickey Mantle, Whitey Ford, Casey Stengel, and Reggie Jackson. In the new millennium, Derek Jeter and Mariano Rivera picked up the torch, carrying it from the Bronx to Cooperstown.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        David Hickey, Kerry Keene, Raymond P. Sinibaldi
      </h2>
      
      <p class="authorDescription body article">Baseball historians Kerry Keene, David Hickey, and Raymond Sinibaldi collaborate once again to tell the riveting story of the Yankees in the Hall of Fame. They also collaborated on Images of Baseball: Dodgers in the Hall of Fame, Images of America: Fenway Park, and The Babe in Red Stockings.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Arcadia Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?aaa7c70e